module.exports = __webpack_public_path__ + "themes/custom/valeo/techassist/assets/media/vin-popin-image.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/vin-popin-image.jpg
// module id = 1031
// module chunks = 0